// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__27e_k","label":"Completed_label__3-zyC"};